var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingDownloadFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 17.2915C2.5 16.7162 2.96637 16.2498 3.54167 16.2498H16.0417C16.617 16.2498 17.0833 16.7162 17.0833 17.2915C17.0833 17.8668 16.617 18.3332 16.0417 18.3332H3.54167C2.96637 18.3332 2.5 17.8668 2.5 17.2915ZM5.9301 9.26327C6.33689 8.85647 6.99644 8.85647 7.40324 9.26327L8.75 10.61L8.75 2.70817C8.75 2.13287 9.21637 1.6665 9.79167 1.6665C10.367 1.6665 10.8333 2.13287 10.8333 2.70817L10.8333 10.61L12.1801 9.26327C12.5869 8.85647 13.2464 8.85647 13.6532 9.26327C14.06 9.67006 14.06 10.3296 13.6532 10.7364L10.5282 13.8614C10.3329 14.0568 10.0679 14.1665 9.79167 14.1665C9.5154 14.1665 9.25045 14.0568 9.0551 13.8614L5.9301 10.7364C5.5233 10.3296 5.5233 9.67006 5.9301 9.26327Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingDownloadFile);
export default __webpack_public_path__ + "static/media/onboarding-download-file.48a1cbe2a57a08cc3abdbd9ed2a740a7.svg";
export { ForwardRef as ReactComponent };